import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';

/** What the signed-in user may do with rate cards. Hiding what they can't is UX only; the server decides (CLAUDE.md → Web conventions). */
export function useRateCardPermissions() {
  const { state } = useCurrentUser();
  const user = state.status === 'authenticated' ? state.user : null;
  const permissions = user?.permissions ?? [];
  return { userId: user?.id, canEdit: permissions.includes('ratecard.edit'), canApprove: permissions.includes('ratecard.approve') };
}
